"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, { createRef, Component } from "react";
import classNames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { TreebeardHeader } from "./TreebeardHeader";
import { TransitionGroup, Transition } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import { ChevronRight } from "../../icons";
import * as styles from "./TreebeardDecorators-css";
const FOLDER_HEIGHT = 48;
let Container = class extends Component {
  constructor(props) {
    super(props);
    this.containerTop = 0;
    this.treeParentTop = 0;
    this.containerRef = createRef();
  }
  componentDidMount() {
    var _a, _b, _c, _d;
    const { treeParentRef } = this.props.node;
    this.containerTop = (_b = (_a = this.containerRef.current) == null ? void 0 : _a.getBoundingClientRect().top) != null ? _b : 0;
    this.treeParentTop = (_d = (_c = treeParentRef == null ? void 0 : treeParentRef.current) == null ? void 0 : _c.getBoundingClientRect().top) != null ? _d : 0;
  }
  render() {
    const { isLoading, animationState, children } = this.props.node;
    const isTerminal = children.length === 0;
    const renderContent = (status) => {
      const showLoadng = isLoading && status !== "entered";
      const transform = showLoadng ? `translate3d(0, -${this.containerTop - this.treeParentTop - FOLDER_HEIGHT}px, 0)` : void 0;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(
            styles.content({ visible: !!status && ["entering", "entered"].includes(status), loading: isLoading })
          ),
          style: { transform }
        },
        isTerminal ? /* @__PURE__ */ React.createElement("div", { className: styles.toggle() }) : /* @__PURE__ */ React.createElement(Toggle, __spreadValues({}, this.props)),
        /* @__PURE__ */ React.createElement(TreebeardHeader, __spreadValues({}, this.props))
      );
    };
    return /* @__PURE__ */ React.createElement("div", { className: "treebeard-container", ref: this.containerRef }, /* @__PURE__ */ React.createElement(TransitionGroup, { component: null }, !!animationState && animationState === "visible" && this.containerTop !== void 0 && /* @__PURE__ */ React.createElement(Transition, { appear: true, timeout: 400, onEnter: forceReflow }, (status) => {
      return renderContent(status);
    })), !animationState && renderContent("entered"));
  }
};
__decorateClass([
  observable.ref
], Container.prototype, "containerTop", 2);
__decorateClass([
  observable.ref
], Container.prototype, "treeParentTop", 2);
Container = __decorateClass([
  observer
], Container);
function Toggle(props) {
  const {
    onClick,
    node: { toggled, id }
  } = props;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: styles.toggle({ expanded: toggled }),
      onClick,
      "aria-expanded": toggled,
      "aria-labelledby": `tree-${id}-folder`,
      id: `tree-${id}-toggle`
    },
    /* @__PURE__ */ React.createElement(ChevronRight, { color: "default" })
  );
}
export const customDecorators = {
  Toggle,
  Header: TreebeardHeader,
  Container
};
export const customTheme = {
  tree: {
    base: {
      background: "transparent"
    }
  }
};
